export function identity<T>(arg: T): T {
  return arg;
}
